/**
 * Create Conditional State id from Symbol id and Layout id
 *
 * @param symbolId
 * @param layoutId
 */
export var buildConditionalStateId = function (symbolId, layoutId) { return symbolId + "_" + layoutId; };
